import { render } from "./TopPanel.vue?vue&type=template&id=bd2ddd72&scoped=true"
import script from "./TopPanel.vue?vue&type=script&lang=js"
export * from "./TopPanel.vue?vue&type=script&lang=js"

import "./TopPanel.vue?vue&type=style&index=0&id=bd2ddd72&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd2ddd72"]])

export default __exports__